<template>
  <div class="header">
    <h1>{{ label }}</h1>
  </div>
</template>

<script>
export default {
  name: "HeaderWithTip",
  props: {
    pageInfo: {},
    label: String
  }
};
</script>

<style scoped>
.header {
  background-color: #06569b;
  min-height: 35px;
}
h1 {
  padding-left: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 12pt;
  font-weight: bold;
  color: white;
}
</style>